import { makeStyles, Typography } from '@material-ui/core';
import { createStyles } from '@material-ui/styles';

import React, { useRef } from 'react';
import { useSpring, animated as a } from 'react-spring';

// interface Props {
//     title: string;
//     content: string;
//     src: string;
// }

const useBlogComponentStyle = makeStyles((theme) =>
    createStyles({
        image: { width: '100%' },
        blogContainer: { width: '90%', cursor: 'pointer', marginBottom: theme.spacing(8) },
        imageContainer: { aspectRatio: '1/1', width: '100%', overflow: 'hidden' },
        title: { fontWeight: 600 }
    })
);

const BlogComponent = ({ title, content, src, id, onSelectBlog, selectedBlog }: any) => {
    const classes = useBlogComponentStyle();
    const imageRef = useRef<HTMLImageElement | null>();
    const imageContainerRef = useRef<HTMLDivElement | null>();

    const imageTopLeft = useRef<any>({ top: 0, left: 0, right: 0, width: 0 });
    const detailContent = useSpring({
        opacity: selectedBlog?.id === id ? 1 : 0,
        transform:
            selectedBlog?.id === id
                ? `translate(${window.innerWidth / 2 + 50}px)`
                : 'translate(2000px)'
    });
    const translate = useSpring({
        transform:
            selectedBlog?.id === id
                ? `translate(${
                      window.innerWidth / 2 -
                      imageTopLeft.current.width * 1.3 -
                      imageTopLeft.current.left
                  }px , ${50}px)) scale(1.3)`
                : 'translate(0px,0px) scale(1)'
    });
    const maxH = useSpring({
        maxHeight: selectedBlog ? 0 : 1000,
        maxWidth: selectedBlog ? 0 : 1000,
        config: { duration: 1000 }
    });
    const trans = useSpring({
        transform: selectedBlog ? `translate()` : `translate(0px)`,
        config: { duration: 1000 }
    });

    // const maxW = useSpring({ width: selectedBlog?.id === id ? '100%' : 'auto' });
    // if (selectedBlog && selectedBlog?.id !== id) return null;
    return (
        <>
            <a.div
                style={{ ...(id !== selectedBlog?.id && maxH && trans) }}
                className={classes.blogContainer}
                onClick={() => {
                    const bound = imageContainerRef.current?.getBoundingClientRect();
                    imageTopLeft.current = {
                        top: bound?.top,
                        left: bound?.left,
                        width: bound?.width,
                        right: bound?.right
                    };
                    onSelectBlog({ id, title, content, src });
                    window.scrollTo({ top: 0, behavior: 'smooth' });
                }}>
                <a.div
                    style={translate}
                    className={classes.imageContainer}
                    ref={(refs) => (imageContainerRef.current = refs)}>
                    <img
                        ref={(refs) => (imageRef.current = refs)}
                        className={classes.image}
                        src={src}
                    />
                </a.div>

                <br />
                <br />
                {!selectedBlog && (
                    <>
                        <Typography color="textPrimary" variant="h6" className={classes.title}>
                            {title}
                        </Typography>
                        <br />
                        <Typography color="textPrimary" variant="body2" className={classes.title}>
                            {content.slice(0, 100)}...
                        </Typography>
                    </>
                )}
            </a.div>
            {selectedBlog && (
                <a.div
                    style={{
                        ...detailContent,
                        position: 'absolute',
                        left: 0,
                        width: imageTopLeft.current.width
                    }}>
                    <Typography color="textPrimary" variant="h6" className={classes.title}>
                        {title}
                    </Typography>
                    <br />
                    <Typography color="textPrimary" variant="body2" className={classes.title}>
                        {content}
                    </Typography>
                </a.div>
            )}
        </>
    );
};

export default BlogComponent;
